const lang = {
    ja: {
        'seminar.time': '開催日 : {year}年{month}月{day}日 ({text})',
        'seminar.placeholderSearch': '検索したい{courseContent}を入力してください',
        'seminar.courseContent': '講座内容',
        'seminar.noteRegister': '{seminarList}を申込む際は「申込みする」ボタンを押し、登録フォームより受講者の情報をご登録ください。',
        'seminar.errorRegister': '登録でエラーが発生しました。これらの{namePage}は登録人数の上限を超えた可能性があります。',
        'seminar.errorRegisterLiveStream': '登録でエラーが発生しました。これらの{namePage}は登録人数の上限を超えた可能性があります。',
        'seminar.errorViewOneMonth': '{name}開催の1ヶ月前のログインは{namePage}のみの表示となります。',
        'seminar.errorViewLimitBfr': '{name}開催の{DiffDay}日前のログインは{namePage}のみの表示となります。',
        'seminar.errorOneMonth': '終了日1ヵ月以上を経過しましたので、セミナー詳細を見ることができません。',
        'seminar.errorOverLimitSmnDetail': '終了日{pastDays}日以上を経過しましたので、セミナー詳細を見ることができません。',
        'seminar.noViewSeminar': '一時停止状態で{name}を閲覧できません。',
        'seminar.register': 'これらを登録しますか？',
        'seminar.selectLeast': '{name}を少なくとも1つを選択してください。',
        'seminar.paymentProcedure': 'お支払い手続き',
        'seminar.applicationDetail': '申込み内容',
        'seminar.taxInclude': '（税込）',
        'seminar.applicationCheck': '申込チェック',
        'seminar.lectureName': '講演名',
        'seminar.lectureContent': '講演内容',
        'seminar.speaker': '講演者',
        'seminar.playTime': '再生時間',
        'seminar.registerSeminar': 'これらの{name}を登録しますか？',
        'seminar.apply': '申し込む',
        'seminar.totalAmount': '合計金額',
        'seminar.period': '期間',
        'seminar.speakerPhoto': '講演者写真',
        'seminar.speakerProfile': '講演者プロフィール',
        'seminar.maxApplicant': '申込最大人数',
        'seminar.contact': '連絡：',
        'seminar.cancelSeminar': '{date}開催予定だったセミナー「{name}」は開催中止となりました。',
        'seminar.paymentStatus': '支払い状況',
        'seminar.approvalStatus': '承認状況',
        'seminar.attendance': '受講',
        'seminar.courseFee': '受講費用',
        'seminar.viewDetail': '講演内容を詳しく見る',
        'seminar.detailSeminarRegister': '受講済みのセミナー詳細',
    },
    en: {
        'seminar.time': '',
        'seminar.placeholderSearch': 'Please enter the {courseContent} to search.',
        'seminar.courseContent': 'the content of a lecture',
        'seminar.noteRegister': 'When you apply for a {seminarList}, click Apply button and register information of participants using the registration form.',
        'seminar.errorRegister': 'An error occurred during registration. The number of participants in these {namePage} might exceed the maximum number of registered participants.',
        'seminar.errorRegisterLivestream': 'An error occurred during registration. The number of participants in this {namePage} might exceed the maximum number of registered participants.',
        'seminar.errorViewOneMonth': 'Display only a {namePage} when logging in a month before the {name} or earlier.',
        'seminar.errorOneMonth': 'More than a month passed after the end date. You cannot view details of the seminar.',
        'seminar.errorViewLimitBfr': 'Display only a {namePage} when logging in {DiffDay} days before the {name} or earlier.',
        'seminar.errorOverLimitSmnDetail': 'More than {pastDays} days after the end date. You cannot view details of the seminar.',
        'seminar.noViewSeminar': '{name} cannot be viewed due to temporary suspension of the service.',
        'seminar.register': 'Are you sure you want to register them?',
        'seminar.selectLeast': 'Please select at least one {name}.',
        'seminar.paymentProcedure': 'Payment procedure',
        'seminar.applicationDetail': 'Content of application',
        'seminar.taxInclude': '(Including tax)',
        'seminar.applicationCheck': 'Check application',
        'seminar.lectureName': 'Lecture title',
        'seminar.lectureContent': 'Content of lecture',
        'seminar.speaker': 'Lecturer',
        'seminar.playTime': 'Duration',
        'seminar.registerSeminar': 'Are you sure you want to register these {name}?',
        'seminar.apply': 'Apply',
        'seminar.totalAmount': 'Total amount',
        'seminar.period': 'Period',
        'seminar.speakerPhoto': 'Photo of the lecturer',
        'seminar.speakerProfile': 'Profile of the lecturer',
        'seminar.maxApplicant': 'Maximum number of applicants',
        'seminar.contact': 'Contact:',
        'seminar.cancelSeminar': 'The seminar “{name}”, scheduled on {date} was canceled.',
        'seminar.paymentStatus': 'Payment status',
        'seminar.approvalStatus': 'Approval status',
        'seminar.attendance': 'Attend',
        'seminar.courseFee': 'Attendance fee',
        'seminar.viewDetail': 'View the details of the seminar',
        'seminar.detailSeminarRegister': 'Details of attended seminars',
    },
};

export default lang;
